(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brokerage', {
            parent: 'entity',
            url: '/brokerage?page&sort&search',
            data: {
                authorities: ['BROKERAGE_READ'],
                pageTitle: 'valueconnectApp.brokerage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage/brokerages.html',
                    controller: 'BrokerageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brokerage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('brokerage-detail', {
            parent: 'entity',
            url: '/brokerage/{id}',
            data: {
                authorities: ['BROKERAGE_READ'],
                pageTitle: 'valueconnectApp.brokerage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage/brokerage-detail.html',
                    controller: 'BrokerageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brokerage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Brokerage', function($stateParams, Brokerage) {
                    return Brokerage.get({id : $stateParams.id}).$promise;
                }]
            }
        })

        .state('brokerage.new', {
            parent: 'brokerage',
            url: '/new',
            data: {
                authorities: ['BROKERAGE_CREATE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage/brokerage-add.html',
                    controller: 'BrokerageAddController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        licenceNumber: null,
                        phoneNumber: null,
                        websiteUrl: null,
                        id: null,
                        reportAccessLevel: 'REDACTED'
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('address');
                    $translatePartialLoader.addPart('brokerage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('brokerage.edit', {
            parent: 'brokerage',
            url: '/{id}/edit',
            data: {
                authorities: ['BROKERAGE_UPDATE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage/brokerage-dialog.html',
                    controller: 'BrokerageDialogController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                entity: ['$stateParams', 'Brokerage', function($stateParams, Brokerage) {
                    return Brokerage.get({id : $stateParams.id}).$promise;
                }]
            }
        })

        .state('brokerage.delete', {
            parent: 'brokerage',
            url: '/{id}/delete',
            data: {
                authorities: ['BROKERAGE_DESTROY']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brokerage/brokerage-delete-dialog.html',
                    controller: 'BrokerageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Brokerage', function(Brokerage) {
                            return Brokerage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brokerage', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        
        .state('brokerage.merge', {
            parent: 'brokerage.edit',
            url: '/merge',
            data: {
                authorities: ['BROKERAGE_UPDATE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brokerage/brokerage-merge.html',
                    controller: 'BrokerageMergeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                brokerageToMergeInto: ['$stateParams', 'Brokerage', function($stateParams, Brokerage) {
                    return Brokerage.get({id: $stateParams.id}).$promise;
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                    return {
                        search: $stateParams.search,
                        page: PaginationUtil.parsePage($stateParams.page)
                    }
                }],
                previousState: ['$state', function($state) {
                    return {
                        name: $state.current.name
                    }
                }],
            },
        });
    }

})();
